module.exports = __webpack_public_path__ + "static/media/solarOn.589f5b6e.png";